const state = {
    error: null,
    inventories: []
};

export default state;
